import { Component, ReactNode, ReactElement } from 'react'
import classnames from 'classnames'

export interface Props {
  text?: string
  Icon?: ReactElement
  className?: string
  tiny?: boolean
  disabled?: boolean
}

export default class Badge extends Component<Props> {
  getInner = (): ReactNode => {
    const { text = '', Icon } = this.props
    return Icon ? Icon : text
  }

  render() {
    const { className = '', Icon, tiny = false, disabled = false } = this.props
    const rootClassName = classnames({
      [className]: true,
      'o-badge': true,
      'o-badge--rounded': !!Icon,
      'o-badge--tiny': tiny,
      'is-disabled': disabled,
    })

    return <span className={rootClassName}>{this.getInner()}</span>
  }
}
